import { useMutation } from "@tanstack/react-query";
import { API_ROUTES } from "~server/routes";
import { fetchApi } from "~app/lib/api-response";
import { toast } from "sonner";
import type {
  RequestPasswordResetRequest,
  RequestResetPasswordResponse,
  ResetPasswordRequest,
  ResetPasswordResponse,
} from "~server/dto/password";

/**
 * Hook to request a password reset email
 */
export function useRequestPasswordReset() {
  return useMutation({
    mutationFn: async (
      data: RequestPasswordResetRequest
    ): Promise<RequestResetPasswordResponse> => {
      return fetchApi(API_ROUTES.AUTH_REQUEST_PASSWORD_RESET(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
    },
    onSuccess: (data) => {
      toast.success("Password reset email sent", {
        description: data.message,
      });
    },
    onError: (error) => {
      toast.error("Failed to send reset email", {
        description: error.message,
      });
    },
  });
}

/**
 * Hook to reset password with token
 */
export function useResetPassword() {
  return useMutation({
    mutationFn: async (
      data: ResetPasswordRequest
    ): Promise<ResetPasswordResponse> => {
      return fetchApi(API_ROUTES.AUTH_RESET_PASSWORD(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
    },
    onSuccess: (data) => {
      toast.success(data.message || "Password reset successful");
    },
    onError: (error) => {
      toast.error("Failed to reset password", {
        description: error.message,
      });
    },
  });
}
